<ng-container *transloco="let t">
  <div class="product-preview">
    @if (galleryImages().length > 0) {
      <div class="gallery-wrapper">
        <pxw-image-gallery
          [images]="galleryImages()"
          [(activeIndex)]="activeGalleryIndex"
          [zoomEnabled]="true"
          (activeIndexChange)="onGalleryImageChange($event)"
          (imageZoom)="onImageZoom($event)"
        />
      </div>
    } @else {
      <div class="content-without-image">{{ t('product.withoutImage') }}</div>
    }
    <pxw-image-zoom
      [popupTitle]="imageToZoomTitle()"
      [zoomImage]="imageToZoom()"
      [(isOpen)]="isZoomOpen"
    />
  </div>

  <div class="product-content">
    <pxw-product-restriction-tags [product]="product()" [purchaseOptions]="purchaseOptions()" />
    @if (!hasPresentations()) {
      <pxw-available-stock
        [stockInfo]="product().id | pxwStockInfo | async"
        [cartItemId]="cartItemId()"
        [stockDisplayCondition]="catalogConfiguration().stockDisplayCondition"
        [stockDisplayConditionValue]="catalogConfiguration().stockDisplayConditionValue"
      />
    }
    <pxw-rich-text
      [text]="product() | propInSelectedLanguage: 'description' : selectedLanguage()"
    ></pxw-rich-text>

    @if (!hasPresentations()) {
      <pxw-product-detail-item-price
        itemType="product-detail"
        [price]="product().price"
        [priceDiscount]="product().priceDiscount"
        [displayProductPriceWithoutTaxes]="displayProductPriceWithoutTaxes()"
        [class.with-promotions]="promotions().length > 0"
      />
    }

    <pxw-product-details-promotion-tags
      [promotions]="promotions()"
      [selectedLanguage]="selectedLanguage()"
    />

    <div>
      @let presentations = product().presentations;

      @if (allPresentationsHidden()) {
        <div class="product-presentations">
          <ng-content select="[presentationsNotice]" />
        </div>
      } @else if (presentations) {
        <div class="product-presentations">
          <pxw-product-option-selector
            itemType="presentation"
            [option]="presentations"
            [(value)]="selectedPresentationOption"
            [selectedLanguage]="selectedLanguage()"
            [cartItemId]="cartItemId()"
            [displayErrors]="isFormSubmitted()"
            [displaySku]="displaySku()"
            [stockDisplayCondition]="catalogConfiguration().stockDisplayCondition"
            [stockDisplayConditionValue]="catalogConfiguration().stockDisplayConditionValue"
            [displayProductPriceWithoutTaxes]="displayProductPriceWithoutTaxes()"
          />
        </div>
      }

      @if (loadingOptions()) {
        <div class="ui-loader ui-loader--inline-block ui-loader--size-sm">
          <pxw-icon icon="loading" [spin]="true"></pxw-icon>
        </div>
      } @else {
        @let customizationOptions =
          product().options | pxwOptionConfigurationsByType: 'customization';
        @let extrasOptions = product().options | pxwOptionConfigurationsByType: 'extras';

        @if (customizationOptions.length > 0) {
          <pxw-product-option-selector-wrapper
            [name]="t('product.customizationOptionsTitle')"
            [instructions]="t('product.customizationOptionsHelper')"
          >
            <div class="product-options-wrapper">
              @for (
                optionConfiguration of customizationOptions;
                track optionConfiguration;
                let i = $index
              ) {
                <pxw-product-option-selector
                  itemType="option-item"
                  [option]="optionConfiguration"
                  [value]="selectedOptions()[i]"
                  (valueChange)="onOptionSelected($event, i)"
                  [cartItemId]="cartItemId()"
                  (itemImageClick)="onItemImageClick($event)"
                  [selectedLanguage]="selectedLanguage()"
                  [displayErrors]="isFormSubmitted()"
                  [displaySku]="displaySku()"
                  [stockDisplayCondition]="catalogConfiguration().stockDisplayCondition"
                  [stockDisplayConditionValue]="catalogConfiguration().stockDisplayConditionValue"
                />
              }
            </div>
          </pxw-product-option-selector-wrapper>
        }

        @if (extrasOptions.length > 0) {
          <pxw-product-option-selector-wrapper
            class="product-option-extras"
            [name]="t('product.extrasOptionsTitle')"
            [instructions]="t('product.extrasOptionsHelper')"
          >
            <div class="product-options-wrapper">
              @for (
                optionConfiguration of extrasOptions;
                track optionConfiguration;
                let i = $index
              ) {
                @let offset = i + customizationOptions.length;

                <pxw-product-option-selector
                  itemType="option-item"
                  [option]="optionConfiguration"
                  [value]="selectedOptions()[offset]"
                  (valueChange)="onOptionSelected($event, offset)"
                  [cartItemId]="cartItemId()"
                  (itemImageClick)="onItemImageClick($event)"
                  [selectedLanguage]="selectedLanguage()"
                  [displayErrors]="isFormSubmitted()"
                  [displaySku]="displaySku()"
                  [stockDisplayCondition]="catalogConfiguration().stockDisplayCondition"
                  [stockDisplayConditionValue]="catalogConfiguration().stockDisplayConditionValue"
                />
              }
            </div>
          </pxw-product-option-selector-wrapper>
        }

        <div class="input-observations">
          <pxw-input-textarea
            name="observations"
            [label]="t('product.observationsLabel')"
            [(ngModel)]="productObservations"
            [placeholder]="t('product.observationsPlaceholder')"
            [maxLength]="150"
            type="textarea"
            [displayErrors]="isFormSubmitted()"
          />
        </div>
      }
    </div>
  </div>
  <ng-content />
</ng-container>
